import logo from '@assets/logos/sj_logo.png';
import logoGeneric from '@assets/logos/generic.svg';
import { NavLink } from 'react-router';
import PropTypes from 'prop-types';
import { isTestMode } from '@util/const.js';
import clsx from 'clsx';

Header.propTypes = {
  onLogoClick: PropTypes.func,
  onMenuClick: PropTypes.func,
  isDrawerOpen: PropTypes.bool,
};

export default function Header({ onLogoClick, onMenuClick, isDrawerOpen , hideMenu=false, logoSubtitle="Play Live Tools",colors={banner:'bg-gray-800 text-gray-100',subtitle:'text-gray-500'}}) {
  const logoInner = (
    <>
      <img
        alt="St. Jude Logo"
        src={`${logo}`}
        className={!isTestMode ? 'w-10' : 'hidden'}
      />
      <img
        alt="Play Live Tools Logo"
        src={`${logoGeneric}`}
        className={isTestMode ? 'w-8 fill-gray-600 opacity-50' : 'hidden'}
      />
      <span className={!isTestMode ? '' : 'hidden'}>St. Jude</span>
      <span className={colors.subtitle}>{logoSubtitle}</span>
    </>
  );

  return (
    <div className={clsx(["navbar",colors.banner, "items-center flex-col"])}>
      <div className="flex-grow md:justify-between transition-all flex items-center w-full">
        <div className="flex-none md:flex-1 hidden md:block">
          <NavLink
            unstable_viewTransition
            className="lg:btn-ghost no-animation text-xl hidden lg:btn"
            to="/"
          >
            {logoInner}
          </NavLink>
        </div>
        {!hideMenu&&<button
          onClick={onMenuClick}
          className={`lg:hidden open-close-button ${isDrawerOpen ? 'open' : ''}`}
        />}
        <div className="flex-2 md:hidden">
          <NavLink
            unstable_viewTransition
            to="/"
            onClick={onLogoClick}
            className="text-lg pr-5 no-animation w-full btn btn-ghost"
          >
            {logoInner}
          </NavLink>
        </div>
        <div className="flex-none"></div>
      </div>
    </div>
  );
}
